<template>
    <div id="app">
        <header class="ritetag-nav-bar">
            <b-container class="nav-bar-container" fixed>
                <app-top-nav-bar :profile-img="info.profileImage"/>
            </b-container>
        </header>

        <notifications position="top center" animation-type="velocity" width="300px"/>

        <b-container class="app-container">
<!--            <b-row v-if="info.loggedIn">-->
            <b-row>
                <b-col class="col-md-3 col-xs-3 route-column">
                    <br>
                    <app-side-nav
                        :currentRoute="currentRoute"
                        v-on:changeRoute="currentRoute = $route.path"
                    />
                </b-col>
                <b-col class="col-md-9 col-xs-9 line-divider">
                    <br>
                    <router-view v-on:changeRoute="currentRoute = $route.path"/>
                </b-col>
            </b-row>
<!--            <b-row v-else>-->
<!--                <b-col class="col-md-12 col-xs-12">-->
<!--                    <br>-->
<!--                    <router-view v-on:changeRoute="currentRoute = $route.path"/>-->
<!--                </b-col>-->
<!--            </b-row>-->
        </b-container>
        <footer>
            <app-main-footer/>
            <div class="collector">
                <app-hashtag-collector v-if="showTagBag"/>
            </div>
        </footer>
    </div>
</template>

<script>
import SideNav from './components/ritetag/SideNav'
import HashtagCollector from './components/ritetag/helpers/HashtagCollector'
import MainFooter from './components/common/MainFooter'
import TopNavBar from './components/common/TopNavBar'

import { mapState, mapActions } from 'vuex'

export default {
    name: 'App',
    components: {
        appSideNav: SideNav,
        appHashtagCollector: HashtagCollector,
        appMainFooter: MainFooter,
        appTopNavBar: TopNavBar
    },
    data() {
        return {
            currentRoute: this.$route.path
        }
    },
    methods: {
        ...mapActions('account', {
            getUserInfo: 'get'
        })
    },
    computed: {
        showTagBag: function () {
            if (this.currentRoute === '/tagsets' || this.currentRoute === '/hashtag-comparison' || this.currentRoute.substr(0, 24) === '/instagram-coach-reports') {
                return true
            } else {
                return false
            }
        },
        ...mapState('account', ['info']),
        loggedIn: function() {
            return this.info.loggedIn
        }
    },
    watch: {
        loggedIn(l) {
            this.$gtm.push({ isLoggedIn: this.info.loggedIn })
            this.$gtm.push({ isDevServer: false })
            this.$gtm.push({ userId: this.info.id })
            this.$gtm.push({ userHash: this.info.userHash })
            this.$gtm.push({ event: 'loggedIn' })
            if (l && this.currentRoute === '/login') {
                this.$router.go('/')
            } else if (!l && this.currentRoute !== '/login') {
                this.$router.go('/login')
            }
        }
    },
    mounted() {
        // this.$store.dispatch('setHashtagSets')
    },
    created() {
        // console.log(this.$route.query)
        // if (this.$route.query.token) {
        //     api.setToken(this.$route.query.token)
        // }
        // if (!api.hasToken()) {
        //     window.location = api.loginUrl()
        // }
        this.getUserInfo()
    }
}
</script>

<style lang="scss" scoped>

.ritetag-nav-bar {
    background-color: $gray-100;
    padding-bottom: 6px;
}
.col-md-3.route-column {
    padding-right: 16px;
}

/deep/ .btn-outline-secondary {
    border-color: $gray-400;
    color: $gray-700;
    &:hover {
        border: 1px solid $gray-400;
    }
    svg {
        color: $gray-600;
    }
}

/deep/ h5 {
    margin-bottom: 20px;
}
/deep/ .btn-secondary {
    border-color: $gray-400;
    background-color: $gray-200;
}

/deep/ table.hide-header thead {
    display:none;
}

/deep/ table.vertical-align-middle td {
    vertical-align: middle;
}

body {
    font-family: "Source Sans Pro";
}

h1,
h2,
h3,
h4,
h5 {
    font-family: "Lato";
    font-weight: 700;
    color: #555;
}

/deep/ .vue-notification {
    font-size: 14px;
    border-radius: $border-radius;
    box-shadow: 0 1px 3px hsla(0,0,0,0.2);
}

/deep/ .vue-notification {
    padding: 10px;
    margin: 5px 5px 5px;
    font-size: 14px;
    color: #ffffff;
    background: $blue-100;
    border: 1px solid $blue-300;
    color: $blue-900;
    &.warn {
        background: $yellow-100;
        border: 1px solid $yellow-500;
        color: $yellow-900;
    }

    &.error {
        background: $red-100;
        border: 1px solid $red-300;
        color: $red-900;
    }

    &.success {
        background: $green-100;
        border: 1px solid $green-300;
        color: $green-900;
    }
}

/deep/ ::placeholder {
    color:$gray-500 !important;
}

.hashtag-legend {
    float: left;
    padding: 8px;
    margin-bottom: 20px;
    width: 100%;
    max-width: 275px;
    font-size: 13px;
    margin-left: auto;
    margin-right: auto;
}

</style>

<style lang="scss"> // Global css for b-modal since it compiled outside <div id='app'>
    .modal-body .btn-outline-secondary {
        border-color: $gray-400 !important;
        color: $gray-700 !important;
        &:hover {
            border: 1px solid $gray-400;
        }
        svg, strong {
            color: $gray-600;
        }
    }
</style>
